import _ from "lodash";
import { members, pancard } from "../../js/path";
export default {
  data() {
    return {
      pageNo: null,
      submitted: false,
      status: false,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      tableData: [],
      products: [],
      currentPage: 1,
      activeTab: "all",
      params: "",
      table_header: [],
      key: 0,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "member_name",
          label: "Member",
        },
        {
          key: "pan_card",
          label: "Pancard",
        },
        {
          key: "bank_name",
          label: "Bank Name",
        },
        {
          key: "account_holder_name",
          label: "Account Holder Name",
        },
        {
          key: "account_no",
          label: "Acccount No",
        },
        {
          key: "ifsc_code",
          label: "IFSC Code",
        },
        {
          key: "branch_name",
          label: "Branch Name",
        },
        {
          key: "survey_name",
        },
        {
          key: "agreement",
        },
        {
          key: "pan_card_image",
        },
        {
          key: "bank_cheque_image",
        },
        {
          key: "verification_status",
          label: "Status",
        },
        {
          key: "is_reject",
          label: "Rejected reasons",
        },
        {
          key: "edit",
        },
        {
          key: "upload",
        },
      ],
      allowedKeys: [
        "member_name",
        "pan_card",
        "bank_name",
        "account_holder_name",
        "account_no",
        "ifsc_code",
        "branch_name",
      ],
      fromBankModal: false,
      form: {
        id: null,
        verification_status: null,
        reason: "",
      },
      form1: {
        id: null,
        account_holder_name: "",
        account_no: "",
        bank_cheque_image: "",
        pan_card_image: "",
        bank_name: "",
        branch_name: "",
        ifsc_code: "",
        pan_card: "",
      },
      form2: {
        member_id: null,
        account_holder_name: "",
        account_no: "",
        bank_cheque_image: "",
        pan_card_image: "",
        bank_name: "",
        branch_name: "",
        ifsc_code: "",
        pan_card: "",
      },
      memberList: [],
      edit: {
        bank_cheque_image: null,
        pan_card_image: null,
        pan_card_image_url: null,
        bank_cheque_image_url: null,
      },
      bank_cheque_image: null,
      pan_card_image_url: null,
      bank_cheque_image_url: null,
      showVerificationModal: false,
      showRejectReasonModal: false,
      rejectReasons: [],
      panImg: null,
      imageModal: false,
      uploadimageModal: false,
      data: {},
      bank_chqeue_image: null,
      pan_card_image: null,
      panCardError: "",
      memberIdError: "",
      uploadBankChequeTxt: false,
    };
  },

  methods: {
    searchFor() {
      if (this.filter.length > 1) this.fetchData();
      else if (this.filter.length == 0) this.fetchData();
    },

    search(event) {
      if (this.filter.length > 1) {
        if (event.keyCode == 13) {
          this.fetchData();
        }
      } else if (this.filter.length == 0) this.fetchData();
    },

    filterPage() {
      if (this.pageNo.length > 0) {
        this.currentPage = this.pageNo;
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    verificationModal(item) {
      this.showVerificationModal = true;
      this.form.id = item.id;
      this.panImg = item.pan_card;
    },

    clearVerificationModel() {
      this.showVerificationModal = false;
      this.form.reason = "";
      this.form.verification_status = null;
      this.panImg = null;
    },

    RejectReasonsModal(id) {
      this.form.id = id;
      this.showRejectReasonModal = true;
      this.fetchreasons();
    },

    clearReasonModel() {
      this.showRejectReasonModal = false;
      this.form.id = "";
    },

    showImageModal(data) {
      this.imageModal = true;
      this.data = data;
    },

    showBankImageModal(data) {
      this.imageModal = true;
      this.data = data;
      this.fromBankModal = true;
    },

    uploadImageModal(id, img) {
      this.uploadimageModal = true;
      this.bank_chqeue_image = img;
      this.form.id = id;
      this.uploadBankChequeTxt = true;
    },

    clearImageModal() {
      this.imageModal = false;
      // this.data = null;
      this.fromBankModal = false;
      this.uploadBankChequeTxt = false;
    },

    clearUploadImageModal() {
      this.uploadimageModal = false;
      this.bank_chqeue_image = null;
      this.form.id = "";
    },

    handleVerificationChange() {
      this.form.reason = "";
    },

    readFile(e, txt) {
      if (txt == "pan_card_image") {
        this.pan_card_image = e.target.files[0];
        if (this.pan_card_image.size > 5 * 1024 * 1024) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Uploaded File is more than 5MB",
          });
          this.$refs.pan_card_image.reset();
          return false;
        } else {
          this.form1.pan_card_image = this.pan_card_image;
          this.form2.pan_card_image = this.pan_card_image;
          this.pan_card_image_url = URL.createObjectURL(this.pan_card_image);
          this.edit.pan_card_image_url = "";
        }
      } else if (txt == "bank_cheque_image") {
        this.bank_cheque_image = e.target.files[0];
        if (this.bank_cheque_image.size > 5 * 1024 * 1024) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Uploaded File is more than 5MB",
          });
          this.$refs.bank_cheque_image.reset();
          return false;
        } else {
          this.form1.bank_cheque_image = this.bank_cheque_image;
          this.form2.bank_cheque_image = this.bank_cheque_image;
          this.bank_cheque_image_url = URL.createObjectURL(
            this.bank_cheque_image
          );
          this.edit.bank_cheque_image_url = "";
        }
      }
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        const maxSize = 150 * 1024; // 150 KB

        // Check if the file type is valid
        if (!allowedTypes.includes(file.type)) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Only .jpg, .jpeg, .png allowed",
          });
          this.$refs.fileInput.value = "";
        }
        // Check if the file size is greater than 150 KB
        else if (file.size > maxSize) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Max file size should be 150 KB",
          });
          this.$refs.fileInput.value = "";
        } else {
          console.log("File is valid:", file);
          this.bank_cheque_image = file ?? "";
        }
      }
    },

    checkNoteValidity() {
      if (this.form.reason == "") {
        this.submitted = true;
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Note Filed Required",
        });
        return false;
      }
      return true;
    },

    async SumbitVerificationStatus() {
      try {
        if (this.form.verification_status === 1) {
          this.$store.commit("loader/updateStatus", true);
          console.log("submited");
          const index = this.tableData.data.findIndex(
            (e) => e.id == this.form.id
          );
          const url = pancard.updateVerificationStatus + `/${this.form.id}`;

          const dataAppend = new FormData();
          for (var key in this.form) {
            if (key !== "id" && key !== "reason") {
              dataAppend.append(key, this.form[key]);
            }
          }
          const res = await this.postRequest(url, dataAppend);
          console.log(res);
          if (res.status) {
            this.tableData.data[index].verification_status = 1;
            this.showVerificationModal = false;
            this.$store.commit("toast/updateStatus", {
              status: true,
              icon: "success",
              title: res.message,
            });
          }
        } else {
          let validateForm = this.checkNoteValidity();
          if (!validateForm) {
            return;
          } else {
            this.$store.commit("loader/updateStatus", true);
            const index = this.tableData.data.findIndex(
              (e) => e.id == this.form.id
            );
            const url = pancard.updateVerificationStatus + `/${this.form.id}`;

            const dataAppend = new FormData();
            for (var k in this.form) {
              if (k !== "id") {
                dataAppend.append(k, this.form[k]);
              }
            }

            const res = await this.postRequest(url, dataAppend);
            if (res.status) {
              this.tableData.data[index].verification_status = 3;
              this.showVerificationModal = false;
              this.$store.commit("toast/updateStatus", {
                status: true,
                icon: "success",
                title: res.message,
              });
            }
          }
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
    },

    tabActive() {
      if (!this.can("edit-pan-card")) {
        let index = this.fields.findIndex((item) => item.key == "edit");
        if (index !== -1) {
          this.fields.splice(index, 1);
          let table_index = this.table_header.findIndex(
            (item) => item == "edit"
          );
          this.table_header.splice(table_index, 1);
        }
      }
    },

    async fetchData(txt) {
      this.$store.commit("loader/updateStatus", true);
      this.status = "";
      if (txt == "verified") {
        this.activeTab = txt;
        this.status = 1;
      } else if (txt == "rejected") {
        this.activeTab = txt;
        this.status = 3;
      } else if (txt == "pending") {
        this.activeTab = txt;
        this.status = 2;
      } else if (txt == "all") {
        this.activeTab = txt;
      }
      let url = `${pancard.getPancard}?page=${this.currentPage ?? 1}&q=${
        this.filter ?? ""
      }&status=${this.status ?? ""}`;
      try {
        const res = await this.getRequest(url);
        if (res) {
          this.tableData = res?.response;
        }
        this.$store.commit("loader/updateStatus", false);
      } catch (err) {
        this.$store.commit("toast/updateStatus"),
          {
            status: true,
            icon: "error",
            title: "somthing went wrong",
          };
        this.$store.commit("loader/updateStatus", false);
      }
    },

    async fetchSingleData(id) {
      this.$store.commit("loader/updateStatus", true);
      try {
        let url = pancard.getPancard + "/get-pan/" + id;
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          if (responseData.id !== "" && responseData.id !== null) {
            this.form1.id = responseData.id;
          }
          if (
            responseData.account_holder_name !== "" &&
            responseData.account_holder_name !== null
          ) {
            this.form1.account_holder_name = responseData.account_holder_name;
          }
          if (
            responseData.account_no !== "" &&
            responseData.account_no !== null
          ) {
            this.form1.account_no = responseData.account_no;
          }
          if (
            responseData.bank_name !== "" &&
            responseData.bank_name !== null
          ) {
            this.form1.bank_name = responseData.bank_name;
          }
          if (
            responseData.branch_name !== "" &&
            responseData.branch_name !== null
          ) {
            this.form1.branch_name = responseData.branch_name;
          }
          if (
            responseData.ifsc_code !== "" &&
            responseData.ifsc_code !== null
          ) {
            this.form1.ifsc_code = responseData.ifsc_code;
          }
          if (responseData.pan_card !== "" && responseData.pan_card !== null) {
            this.form1.pan_card = responseData.pan_card;
          }
          if (
            responseData.pan_card_image !== "" &&
            responseData.pan_card_image !== null
          ) {
            this.edit.pan_card_image_url = responseData.pan_card_image;
          }
          if (
            responseData.bank_cheque_image !== "" &&
            responseData.bank_cheque_image !== null
          ) {
            this.edit.bank_cheque_image_url = responseData.bank_cheque_image;
          }
        }
        this.$store.commit("loader/updateStatus", false);
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
    },

    async updateData() {
      this.$store.commit("loader/updateStatus", true);
      try {
        let data = [];
        if (
          this.form1.pan_card.length >= 1 &&
          this.form1.pan_card.length !== 10
        ) {
          this.panCardError = "PAN card number must be exactly 10 characters.";
          this.$store.commit("loader/updateStatus", false);
          return;
        }
        let dataAppend = new FormData();
        for (let key in this.form1) {
          dataAppend.append(key, this.form1[key]);
        }
        dataAppend.append("_method", "put");
        console.log("sdsd--", this, this.uploadBankChequeTxt);
        if (this.uploadBankChequeTxt && this.bank_cheque_image) {
          let url = `${pancard.getPancard}/${this.form.id}`;
          let uploadModal = new FormData();
          if (this.bank_cheque_image) {
            uploadModal.append("bank_cheque_image", this.bank_cheque_image);
            uploadModal.append("_method", "put");
          }
          data = await this.postRequest(url, uploadModal);
        } else {
          let url = `${pancard.getPancard}/${this.form1.id}`;
          data = await this.postRequest(url, dataAppend);
        }
        if (data?.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data?.message ?? "Data updated successfully",
          });
          this.image = null;
        } else {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Something went wrong",
          });
        }
        this.$nextTick(() => {
          this.$bvModal.hide("uploadimageModal");
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Something went wrong",
        });
        this.$nextTick(() => {
          this.$bvModal.hide("uploadimageModal");
        });
      }
      this.$store.commit("loader/updateStatus", false);
      this.uploadimageModal = false;
      if (this.$route.path === "/pancard") {
        this.fetchData();
      } else {
        this.$router.push("/pancard");
      }
    },

    async addData() {
      this.$store.commit("loader/updateStatus", true);
      console.log("sddddddddddd-------", this);

      try {
        let data = [];
        if (this.form2.member_id == null) {
          this.memberIdError = "Please select member";
          this.$store.commit("loader/updateStatus", false);
          return;
        }
        if (
          this.form2.pan_card.length >= 1 &&
          this.form2.pan_card.length !== 10
        ) {
          this.panCardError = "PAN card number must be exactly 10 characters.";
          this.$store.commit("loader/updateStatus", false);
          return;
        }
        let dataAppend = new FormData();
        for (let key in this.form2) {
          if (key === "member_id") {
            dataAppend.append("member_id", this.form2.member_id.member_id);
          } else {
            dataAppend.append(key, this.form2[key]);
          }
        }
        let url = `${pancard.getPancard}`;
        data = await this.postRequest(url, dataAppend);

        if (data?.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data?.message ?? "Data updated successfully",
          });
          this.image = null;
        } else {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Something went wrong",
          });
        }
        this.$nextTick(() => {
          this.$bvModal.hide("uploadimageModal");
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Something went wrong",
        });
        this.$nextTick(() => {
          this.$bvModal.hide("uploadimageModal");
        });
      }
      this.$store.commit("loader/updateStatus", false);
      this.uploadimageModal = false;
      this.$router.push("/pancard");
    },

    fetchMemberList: _.debounce(async function (query) {
      this.$store.commit("loader/updateStatus", false);
      this.memberList = [];
      if (query != "" && query != null) {
        this.$store.commit("loader/updateStatus", true);
        const url = members.getMembers;
        const data = await this.getRequest(url + "?search=" + query);
        if (data.status) {
          this.memberList = data.response.data.map((member) => ({
            member_id: member.id,
            fnameAndLname: `${member.fname} ${member.lname} - ${member.mobile_number}`,
          }));
        }
      }
      this.$store.commit("loader/updateStatus", false);
    }, 1000),

    async fetchreasons() {
      this.$store.commit("loader/updateStatus", true);

      let url = `${pancard.getPancard}/${this.form.id}`;
      try {
        const res = await this.getRequest(url);
        if (res) {
          this.rejectReasons = res?.response;
        }
        this.$store.commit("loader/updateStatus", false);
      } catch (err) {
        this.$store.commit("toast/updateStatus"),
          {
            status: true,
            icon: "error",
            title: "somthing went wrong",
          };
        this.$store.commit("loader/updateStatus", false);
      }
    },
  },
  watch: {
    currentPage: {
      handler: function (v) {
        if (v != "" && v != null) {
          this.fetchData(this.activeTab);
          this.pageNo = this.currentPage;
        }
      },
    },
    activeTab(v) {
      if (v) this.tabActive();
    },
  },
  props: {
    image: String,
  },
  computed: {
    isPdf() {
      return this.image?.toLowerCase().endsWith(".pdf");
    },
  },
  created() {
    if (this.$route.name == "edit-pan-card") {
      this.fetchSingleData(this.$route.params.id);
    } else if (this.$route.name == "pancard") {
      this.fetchData();
    }
    this.fields.map((item) => {
      this.table_header.push(item.key);
    });
    this.tabActive();
  },
};
